import type mapboxgl from "mapbox-gl";

export function computeLockedCorners(
  img: HTMLImageElement,
  map: mapboxgl.Map
): [number, number][] {
  const i = img.getBoundingClientRect();
  const c = map.getContainer().getBoundingClientRect();
  const dx = i.left - c.left;
  const dy = i.top - c.top;
  const tl = map.unproject([dx, dy]);
  const tr = map.unproject([dx + i.width, dy]);
  const br = map.unproject([dx + i.width, dy + i.height]);
  const bl = map.unproject([dx, dy + i.height]);
  return [
    [tl.lng, tl.lat],
    [tr.lng, tr.lat],
    [br.lng, br.lat],
    [bl.lng, bl.lat],
  ];
}
